import { accelerationStore } from "@/stores/acceleration";
import { genBlock } from "@/utils/bem";
import { useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { Box, Flex, Text, chakra } from "@chakra-ui/react";
import React from "react";
import "./style.scss";

const block = genBlock("c-free-task-message");
const _FreeTaskMessage: React.FC = () => {
  const { translate } = useTranslate();
  return (
    <Box fontSize="14px">
      <Text>{translate(Editor_Words["free-task-already-in-queue-message"])}</Text>
      <Flex>
        （使用&nbsp;
        <chakra.div
          className={block("label-gradient-text")}
          cursor="pointer"
          onClick={() => accelerationStore.setPaymentModalOpen(true)}
        >
          加速通道
        </chakra.div>
        &nbsp;不限量提交任务）
      </Flex>
    </Box>
  );
};

export const FreeTaskMessage = chakra(_FreeTaskMessage);

export const FreeTaskMessageElement = <FreeTaskMessage />;
